import styled from 'styled-components';
import PropTypes from 'prop-types';

export const Container = styled.div`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  margin-top: 1rem;
`;

Container.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

Container.displayName = 'Container';
